import React, { useState } from "react";
import Image from "components/common/utils/Image";
import { Link } from "gatsby";
import "./styles.sass";
import cx from "classnames";
import T from "types/index";
import { pathologiesDaughterSlug, pathologiesMotherSlug } from "templates/Pathologies/utils/slugs";
import LinkOrAOrText from "components/common/links/LinkOrAOrText";

type Props = {
  sections: T.Standard.FooterAccordionSection[];
  column?: boolean;
  wideGapItems?: boolean;
  whiteVersion?: boolean;
};

const FooterAccordion = ({
  sections,
  whiteVersion = true,
  wideGapItems = false,
  column = false,
}: Props) => {

  return (
    <div
      className={cx("landing-footer-end-link-section", {
        "text-white": whiteVersion,
      })}
    >
      <div
        className={cx("landing-footer-end-link-wrapper", {
          "flex-lg-column": column,
        })}
      >
        {sections.map(
          (section: T.Standard.FooterAccordionSection, index: number) => (
            <FooterAccordionSection
              section={section}
              whiteVersion={whiteVersion}
              wideGapItems={wideGapItems}
              column={column}
              key={`end-footer-${index}`}
            />
          )
        )}
      </div>
    </div>
  );
};

const FooterAccordionSection = ({
  whiteVersion,
  wideGapItems,
  column,
  section,
}: {
  whiteVersion: boolean;
  wideGapItems: boolean;
  column: boolean;
  section: T.Standard.FooterAccordionSection;
}) => {
  const tag = whiteVersion
    ? "new-images/white-tag.svg"
    : "new-images/black-tag.svg";
  const linkVersion = whiteVersion
    ? "landing-footer-end-link-category-white"
    : "landing-footer-end-link-category-black";
  const [openedSection, openCloseSection] = useState(false)
  return (
    <div className={cx("landing-footer-end-link-category", linkVersion)}>
      <div
        onClick={() => openCloseSection(!openedSection)}
        className="landing-footer-end-link-category-title"
      >
        <LinkOrAOrText anchor={section.title} to={section.titleLink} className={cx("h4", { "text-white": whiteVersion })}/>
        <Image
          filename={tag}
          className={cx("landing-footer-end-link-category-tag d-xl-none", {
            "rotate-end-tag": openedSection,
          })}
          alt={`white-tag--${section.title}`}
          title={`white tag ${section.title}`}
        />
      </div>
      <ul
        className={cx("landing-footer-end-link-list", {
          "inline-accordion": column,
          "expand-end-list": openedSection,
        })}
      >
        {section.items.map(
          (item: T.Standard.FooterAccordionSectionItem, subIndex: number) => (
            <li
              className={cx({ "wide-gap-li": wideGapItems })}
              key={`end-footer-${item.title}-category-link-${subIndex}`}
            >
              <LinkOrAOrText
                anchor={item.title}
                to={item.link}
                href={item.href}
                className={cx("pr-2", { "text-white": whiteVersion })}
                rel={item.rel}
              />
            </li>
          )
        )}
      </ul>
    </div>
  );
};

export default FooterAccordion;


export const sectionForCategory = (categoryRecord: T.Charles.CategoryRecord, excludePathoIds: string[]): T.Standard.FooterAccordionSection => {
  const pathologies = categoryRecord.data.pathologies
  const displayedPathologies: T.Charles.PathologyRecord[] = pathologies.filter((pathologyRecord: T.Charles.PathologyRecord) => excludePathoIds.indexOf(pathologyRecord.id) === -1)
  return {
    title: categoryRecord.data.name,
    titleLink: pathologiesMotherSlug(categoryRecord.data.slug),
    items: displayedPathologies.map(
      (pathologyRecord: T.Charles.PathologyRecord) => ({
        title: pathologyRecord.data.breadcrumb_label,
        link: pathologiesDaughterSlug(
          categoryRecord.data.slug,
          pathologyRecord.data.slug
        ),
      })
    ),
}}

export const sectionForOtherCategories = (categoriesRecords: T.Charles.CategoryRecord[]): T.Standard.FooterAccordionSection => ({
  title: "Nos autres spécialités",
  items: categoriesRecords.map(
    (categoryRecord: T.Charles.CategoryRecord) => ({
      title: categoryRecord.data.name,
      link: pathologiesMotherSlug(
        categoryRecord.data.slug
      ),
    })
  ),
})
